import VanityCabinetSubPartCommon from "./vanityCabinetSubPartCommon";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, VANITY_TYPES} from "../../constants";

export default class DrawerHandle extends VanityCabinetSubPartCommon {

  constructor(isChild) {
    super(isChild);
    this.partId = 'drawer_handle';
    this.partName = 'Drawer Handle';
    this.translateId = "visualizer.kitchen.cabinet.drawer_handle";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = false;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    const parent = this.getParent();
    if (!this.disabled && parent.vanityCabinet?.disabled) {
      parent.toggleVanityParts(this.disabled);
    }
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityCabinet || vanityParent.vanityCabinet.disabled || !vanityParent.vanityCabinet.activeFeature
      || vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    conditions.push({
      propName: "VanitySize",
      propValue: vanityParent.counterTopSize(this)
    })
    if (vanityParent.vanityCabinet && vanityParent.vanityCabinet.activeFeature
      && vanityParent.vanityCabinet.activeFeature.metaData["HandlePosition"]) {
      conditions.push({
        propName: "HandlePosition",
        propValue: vanityParent.vanityCabinet.activeFeature.metaData["HandlePosition"]
      });
    }
    const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(VANITY_TYPES.vanity_cabinet, "Side");
    if (activeSideMeta && activeSideMeta.includes("C")) {
      conditions.push({
        propName: "Side",
        propValue: activeSideMeta
      });
    }
    if (!vanityParent.vanityCabinet || !vanityParent.vanityCabinet.activeFeature
      || !vanityParent.vanityCabinet.activeFeature.metaData["Drawer"]) {
      // Do Not Render Drawer Handle With Old Cabinets, they don't have this metadata
      conditions.push({
        propName: "Hide",
        propValue: "Yes"
      });
    }
    return conditions
  }
}
